if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // ※ 商品フォームは novalidate のため、required/pattern は JS で担保する
        // ※ form.id はフォーム内の name="id" 要素と衝突するため getAttribute で取得
        const formId = this.form.getAttribute("id");
        let hasValidationError = false;
        let validationMessage = "すべてのフィールドを入力してください";
        let firstInvalidInput = null;

        // テキスト入力プロパティの必須バリデーション
        const requiredPropertyInputs = document.querySelectorAll(
          `text-input-property[data-form-id="${formId}"] input[required]`,
        );
        requiredPropertyInputs.forEach((input) => {
          const errorMessageEl = input
            .closest(".text-input-property__field-group")
            ?.querySelector(".text-input-property__error-message");
          if (!input.value.trim()) {
            hasValidationError = true;
            input.classList.add("field__input--error");
            if (errorMessageEl) errorMessageEl.hidden = false;
            if (!firstInvalidInput) firstInvalidInput = input;
          } else {
            input.classList.remove("field__input--error");
            if (errorMessageEl) errorMessageEl.hidden = true;
          }
        });

        // ID入力（英数字6桁＋有効性チェック）のバリデーション
        // 検証成功（data-verified="true"）でないと送信を許可しない
        const idInputElements = document.querySelectorAll(
          `id-input[data-form-id="${formId}"]`,
        );
        idInputElements.forEach((el) => {
          const input = el.querySelector("input");
          if (!input) return;
          const value = input.value.trim();
          const needsVerification = input.required || value !== "";
          const verified = el.dataset.verified === "true";
          if (needsVerification && !verified) {
            hasValidationError = true;
            input.classList.add("field__input--error");
            if (!firstInvalidInput) firstInvalidInput = input;
            validationMessage = "IDを入力し「確認」ボタンで有効性を確認してください";
          } else {
            input.classList.remove("field__input--error");
          }
        });

        // 入力不備があればカート追加を中断し、最初の該当フィールドにフォーカス
        if (hasValidationError) {
          if (firstInvalidInput) firstInvalidInput.focus();
          this.handleErrorMessage(validationMessage);
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers",
            );
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker,
                );
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      },
                    );
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
